import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Container } from './styles';
import { IFabricationContract } from '../../../../../store/ducks/fabrication-contracts/types';
import moment from 'moment';
import OptionsColumn from './OptionsColumn';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import Table from '../../../../../components/Table';

interface ConstructionIdentificationLastOrdersTableProps {
  selectedContract?: IFabricationContract;
  onBuyAgainClick(orderId: number): void;
}

interface ConstructionIdentificationTableDataSource {
  key: number;
  orderNumber: string;
  sendDate: string;
  orderId: number;
}

const ConstructionIdentificationLastOrdersTable: React.FC<
  ConstructionIdentificationLastOrdersTableProps
> = ({ selectedContract, onBuyAgainClick }) => {
  const [constructionIdentificationData, setConstructionIdentificationData] =
    useState<ConstructionIdentificationTableDataSource[]>([]);

  const dispatch = useDispatch();
  const { location } = useHistory();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    location.pathname,
    true
  );

  const columns = [
    {
      title: 'Pedidos',
      dataIndex: 'orderNumber',
      width: '10rem',
      sorter: (
        a: ConstructionIdentificationTableDataSource,
        b: ConstructionIdentificationTableDataSource
      ) =>
        a.orderNumber < b.orderNumber
          ? -1
          : a.orderNumber > b.orderNumber
          ? 1
          : 0,
      render: (text: string) => <>{text}</>
    },
    {
      title: 'Data de criação',
      dataIndex: 'sendDate',
      width: '7rem',
      sorter: (
        a: ConstructionIdentificationTableDataSource,
        b: ConstructionIdentificationTableDataSource
      ) =>
        moment(a.sendDate, 'YYYY-MM-DD').toDate().getTime() -
        moment(b.sendDate, 'YYYY-MM-DD').toDate().getTime(),
      render: (sendDate: string) => (
        <>{moment(sendDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</>
      )
    },
    {
      title: 'Opções',
      dataIndex: 'orderId',
      width: '6rem',
      render: (orderId: number) => (
        <OptionsColumn
          orderId={orderId}
          contractNumber={selectedContract?.contractNumber || ''}
        />
      )
    },
    {
      title: ' ',
      dataIndex: 'orderId',
      width: '6rem',
      render: (orderId: number) => (
        <Button
          type="button"
          name="button-on-by-again"
          variant="tertiary"
          onClick={() => {
            onBuyAgainClick(orderId);
            dispatch(
              sendTagging({
                screenName,
                page: location.pathname,
                itemName: 'button:recomprar',
                itemDescription: `${itemDescription}_recomprar`,
                event: 'click'
              })
            );
          }}
          icon={<Icon option="Cart" />}
        >
          Recomprar
        </Button>
      )
    }
  ];

  useEffect(() => {
    if (!selectedContract?.lastOrderDetails) {
      return;
    }

    const data: ConstructionIdentificationTableDataSource[] =
      selectedContract.lastOrderDetails.map((order, idx) => {
        return {
          key: idx,
          orderNumber: order.orderNumber,
          sendDate: order.sendDate,
          orderId: order.id
        };
      });

    setConstructionIdentificationData(data);
  }, [selectedContract?.lastOrderDetails]);

  return (
    <Container>
      <Table
        columns={columns}
        data={constructionIdentificationData}
        scroll={{
          x: 'calc(15rem + 50%)'
        }}
        hasPagination
      />
    </Container>
  );
};

export default ConstructionIdentificationLastOrdersTable;
